import { Reveal, FadeUp } from "@/components/site/Reveal";
import { PROCESS } from "@/data/content";

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="relative bg-[#f8fafc] py-24 md:py-40">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <p className="overline !text-[#9c7a4d] mb-6">The Method</p>
            <h2 className="font-serif font-light text-[#0f172a] text-4xl md:text-6xl leading-[0.98] tracking-tight lg:sticky lg:top-32">
              <Reveal>How the</Reveal>
              <Reveal delay={0.08}>work gets</Reveal>
              <Reveal delay={0.16}>done.</Reveal>
            </h2>
          </div>

          <div className="lg:col-span-8 lg:col-start-5">
            <div className="divide-y divide-[#0f172a]/10 border-t border-[#0f172a]/10">
              {PROCESS.map((step, i) => (
                <FadeUp key={step.n} delay={i * 0.05}>
                  <div className="grid grid-cols-1 md:grid-cols-12 gap-6 py-10 md:py-14 group">
                    <h3 className="md:col-span-4 font-serif text-2xl md:text-3xl text-[#0f172a] font-light">{step.title}</h3>
                    <p className="md:col-span-8 text-[#475569] text-base md:text-lg font-light leading-relaxed">{step.body}</p>
                  </div>
                </FadeUp>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
